import { render, staticRenderFns } from "./SvgPauseBars.vue?vue&type=template&id=36e7bba8&lang=pug&"
import script from "./SvgPauseBars.vue?vue&type=script&lang=js&"
export * from "./SvgPauseBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports